import { h } from 'preact';
import { PureComponent } from 'preact/compat';
import { withContext } from '../../common/context';
import Popup from '../Popup/Popup';

class ZoomPopup extends PureComponent {
  state = {
    isZoomed: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.zoomIn !== this.props.zoomIn) {
      if (this.props.zoomIn) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    }
  }

  componentWillUnmount() {
    this.zoomOut();
    document.body.removeEventListener('keydown', this.handleEsc);
  }

  handleEsc = e => {
    if (e.key === 'Escape') {
      this.zoomOut();
      e.preventDefault();
    }
  };

  zoomIn = () => {
    this.setState({ isZoomed: true });
    document.body.addEventListener('keydown', this.handleEsc);
  };

  zoomOut = () => {
    this.props.setZoom(-1);
    this.setState({ isZoomed: false });
    document.body.removeEventListener('keydown', this.handleEsc);
  };

  render(props, state) {
    const { config } = props.context;

    return state.isZoomed ? (
      <Popup
        onClose={this.zoomOut}
        index={props.index}
        prevItem={props.prevItem}
        nextItem={props.nextItem}
        onItemSwipe={props.onItemSwipe}
        keyDownHandler={props.keyDownHandler}
        setZoom={props.setZoom}
        {...config.selectZoomPopupProps()}
      />
    ) : null;
  }
}

export default withContext(ZoomPopup);
